// The reasons a member can give in a report (backend models/blockReportUser.js
// reports[].type), with the words the report views show. "Fake name" was
// added for 2.6 (founder 2026-10-15): a member reporting that the name they
// see is not a real first name. It sits in the queue like any other reason.
export const REPORT_TYPES = [
  { value: "abusive_behavior", label: "Abusive behavior" },
  { value: "harassment", label: "Harassment" },
  { value: "spam", label: "Spam" },
  { value: "fake_profile", label: "Fake profile" },
  { value: "fake_name", label: "Fake name" },
  { value: "fake_item", label: "Fake item" },
  { value: "scam", label: "Scam" },
  { value: "inappropriate_content", label: "Inappropriate content" },
  { value: "other", label: "Other" },
  { value: "block_reason", label: "Block reason" },
];

const fallback = (str) =>
  String(str)
    .replace(/_/g, " ")
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

/** The words for a reason; an unknown one is spelled out from its value. */
export const reportTypeLabel = (type) => {
  if (!type) return "N/A";
  const hit = REPORT_TYPES.find((t) => t.value === type);
  return hit ? hit.label : fallback(type);
};

/**
 * The report-type filter: every known reason, in the order above, then any
 * other reason found on the page (an older or newer value), so Fake name can
 * be picked before the first one arrives.
 */
export const reportTypeOptions = (present = []) => {
  const known = REPORT_TYPES.map((t) => t.value);
  const extra = [...new Set(present.filter((t) => t && !known.includes(t)))];
  return [...known, ...extra].map((value) => ({ value, label: reportTypeLabel(value) }));
};
